import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_walking.pages.landing.step_1.title'),
			size: 'large',
			uppercase: true,
			customStyles: {
				marginLeft: '3rem',
				marginRight: '3rem',
			},
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => {
			let img = null

			try {
				img = require(`@/assets/landing/spreadsheet/${ctx.language}.png`)
			} catch {
				img = require('@/assets/landing/spreadsheet-walking/en.png')
			}

			return {
				img,
				customStyles: {
					paddingTop: 'var(--size-8)',
					paddingBottom: 'var(--size-8)',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
